<app-loader [loaded]="loaded" [progress]="loadingProgress"></app-loader>
<app-nav></app-nav>
<app-ui-menu
  [eventDataImportOptions]="eventDataImportOptions"
  [uiConfig]="uiConfig"
>
  <!-- LHCb specific VP toggle -->
  <app-cycle-events [interval]="5000"></app-cycle-events>
  <app-vp-toggle></app-vp-toggle>
</app-ui-menu>
<app-embed-menu></app-embed-menu>
<app-experiment-info
  logo="assets/images/lhcb.svg"
  url="https://home.cern/science/experiments/lhcb"
  tagline="LHCb Experiment at CERN"
></app-experiment-info>
<app-phoenix-menu [rootNode]="phoenixMenuRoot"></app-phoenix-menu>
<div id="eventDisplay"></div>
